import { render, staticRenderFns } from "./IndependentSelection.vue?vue&type=template&id=4bc4add0"
import script from "./IndependentSelection.vue?vue&type=script&lang=js"
export * from "./IndependentSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports